import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';
import { a as attachObserverToInput } from './inputObserver-6de9a524.js';

const gravityColorInputCss = ".gravity-color-input{display:flex;flex-direction:column;position:relative}.gravity-color-input__native-input{border:0;bottom:-8px;clip:rect(0 0 0 0);clip-path:inset(50%);height:0;left:0;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:0}.gravity-color-input__color-trigger{border:1px inset rgba(0, 15, 30, 0.2);border-radius:2px;box-sizing:border-box;cursor:pointer;height:18px;min-width:18px}.gravity-color-input__color-trigger--empty{background:center/contain no-repeat url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGxpbmUgeDE9IjAiIHkxPSIxOCIgeDI9IjE4IiB5Mj0iMCIgc3Ryb2tlPSIjREIwQTQwIiBzdHJva2Utd2lkdGg9IjEiLz48L3N2Zz4=\") #fff}.gravity-color-input__native-input:focus-visible+.gravity-color-input__color-trigger{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-color-input__color-trigger:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-color-input--disabled:not(.gravity-color-input--highlighted) .gravity-color-input__color-trigger,.gravity-color-input--disabled:not(.gravity-color-input--highlighted) .gravity-color-input__color-trigger:hover{border-color:rgba(0, 15, 30, 0.2);cursor:default}.gravity-color-input--disabled:not(.gravity-color-input--highlighted) .gravity-color-input__color-trigger:focus{outline:none}.gravity-color-input__input-block{align-items:center;background-color:#FFFFFF;border-bottom:var(--gravity-color-input-border-bottom, 1px solid rgba(0, 15, 30, 0.2));border-left:var(--gravity-color-input-border-left, 1px solid rgba(0, 15, 30, 0.2));border-radius:var(--gravity-color-input-border-radius, 6px);border-right:var(--gravity-color-input-border-right, 1px solid rgba(0, 15, 30, 0.2));border-top:var(--gravity-color-input-border-top, 1px solid rgba(0, 15, 30, 0.2));box-sizing:border-box;display:flex;flex-direction:row;gap:6px;min-height:40px;padding-inline:12px}.gravity-color-input__input-block:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-color-input__input-block:has(.gravity-color-input__input:focus-visible){outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-color-input--disabled .gravity-color-input__input-block{background-color:rgba(0, 15, 30, 0.05)}.gravity-color-input--disabled .gravity-color-input__input-block,.gravity-color-input--disabled .gravity-color-input__input-block:hover{background-color:rgba(0, 15, 30, 0.05);border-color:transparent}.gravity-color-input--disabled .gravity-color-input__input-block:focus-within{outline:none}.gravity-color-input--highlighted .gravity-color-input__input-block{background-color:#F4F8FE}.gravity-color-input--highlighted .gravity-color-input__input-block:hover,.gravity-color-input--highlighted .gravity-color-input__input-block:has(.gravity-color-input--disabled){background-color:#F4F8FE}.gravity-color-input__input{background-color:transparent;border:0;color:#000F1E;display:flex;flex:1;font-family:\"Bull\", Helvetica, sans-serif;font-size:16px;line-height:1.5;padding:0;width:100%}.gravity-color-input__input:focus{outline:none}.gravity-color-input__input::placeholder{color:rgba(0, 15, 30, 0.4);font-weight:normal}.gravity-color-input--disabled .gravity-color-input__input{color:rgba(0, 15, 30, 0.4)}.gravity-color-input--highlighted .gravity-color-input__input{color:#175ACA}.gravity-color-input__clear-button{align-items:center;background:rgba(0, 15, 30, 0.1);border:0;border-radius:9999px;cursor:pointer;display:none;display:none;justify-content:center;padding:0}.gravity-color-input:hover .gravity-color-input__clear-button,.gravity-color-input:focus-within .gravity-color-input__clear-button{display:flex}.gravity-color-input__clear-button:focus{outline:none}.gravity-color-input__clear-button:hover,.gravity-color-input__clear-button:focus{background:rgba(0, 15, 30, 0.2)}.gravity-color-input--invalid .gravity-color-input__input-block{border-color:#DB0A40}.gravity-color-input--size-small .gravity-color-input__input{font-size:14px;line-height:1.428571}.gravity-color-input--size-small .gravity-color-input__input-block{border-radius:var(--gravity-color-input-border-radius, 4px);gap:4px;height:32px;min-height:32px;padding-inline:8px}";
const GravityColorInputStyle0 = gravityColorInputCss;

const generateClassNames = bem('gravity-color-input');
const GravityColorInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.clear = createEvent(this, "clear", 7);
        this.colorChanged = createEvent(this, "colorChanged", 5);
        this.colorInput = createEvent(this, "colorInput", 5);
        this.HEX_COLOR_REGEX = new RegExp(/^#{0,1}([A-F0-9]{3}|[A-F0-9]{6})$/, 'i');
        this.INPUT_MAX_LENGTH = 6;
        this.clearable = true;
        this.disabled = false;
        this.highlighted = false;
        this.infoBottom = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = undefined;
        this.placeholder = 'Enter a hex code';
        this.required = false;
        this.size = 'medium';
        this.validationMessage = '';
        this.value = '';
        this.inputValue = undefined;
        this.valueInvalid = false;
        this.valueMissing = false;
    }
    handleValueChange(newValue) {
        this.validate();
        if (!!this.value && !this.valueInvalid) {
            newValue = this.normalizeValue(newValue);
        }
        this.value = newValue;
        this.inputValue = newValue;
    }
    /**
     * Resets the input
     */
    async reset() {
        this.valueMissing = false;
        this.invalid = false;
        this.validationMessage = '';
        this.value = '';
        this.colorChanged.emit(this.value);
        this.inputValue = '';
    }
    renderClearButton() {
        if (this.disabled || !this.clearable || !this.inputValue) {
            return;
        }
        return (h("button", { class: generateClassNames('clear-button'), onMouseDown: (event) => {
                this.clearInput(event);
            }, tabindex: -1 }, h("gravity-icon", { class: "clear-button__icon", name: "close", color: "dark", size: "xxx-small" })));
    }
    clearInput(event) {
        event.stopPropagation();
        this.clear.emit();
        this.input.value = '';
        this.value = '';
        this.valueInvalid = false;
        this.valueMissing = false;
        this.inputValue = '';
        this.colorTrigger.setAttribute('style', '');
        this.colorChanged.emit(this.value);
    }
    getValidationMessage() {
        if (this.validationMessage) {
            return this.validationMessage;
        }
        if (this.valueInvalid) {
            return 'Please enter a valid Hex code';
        }
        if (this.valueMissing) {
            return 'This field is required';
        }
        return '';
    }
    renderDisplayValue(value) {
        var _a, _b;
        if (this.valueInvalid) {
            return value;
        }
        return (_b = (_a = value.split('#')[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : value;
    }
    validate() {
        this.valueInvalid = Boolean(this.value && !this.isValidHexCode(this.value));
        this.valueMissing = this.required && !this.value;
    }
    handleColorTriggerKeyDown(event) {
        const { key } = event;
        if (key === 'Enter' || key === ' ') {
            this.handleColorTriggerClick();
        }
    }
    handleColorTriggerClick() {
        if (this.disabled) {
            return;
        }
        this.nativeInput.click();
    }
    handleFormFieldClick(event) {
        const target = event.target;
        if (target && (this.nativeInput.contains(target) || this.colorTrigger.contains(target))) {
            return;
        }
        this.input.focus();
    }
    handleColorSwatchInput(event) {
        const { value } = event.target;
        if (value === this.value) {
            return;
        }
        this.value = value;
        this.colorTrigger.setAttribute('style', `background: ${value}`);
        this.colorInput.emit(this.normalizeValue(value));
    }
    handleColorSwatchChange() {
        const value = this.nativeInput.value;
        if (value !== this.value) {
            this.value = value;
            this.inputValue = value;
        }
        this.colorChanged.emit(this.normalizeValue(this.value));
    }
    handleInputInput(event) {
        const inputElement = event.target;
        const value = inputElement.value;
        const valueWithoutHash = value.replace('#', '');
        if (valueWithoutHash.length > this.INPUT_MAX_LENGTH) {
            inputElement.value = this.renderDisplayValue(this.inputValue);
            return;
        }
        this.valueInvalid = false;
        this.valueMissing = false;
        this.inputValue = value;
        if ((valueWithoutHash.length === 3 || valueWithoutHash.length === 6) && this.isValidHexCode(valueWithoutHash)) {
            const normalizedValue = this.normalizeValue(value);
            this.colorTrigger.setAttribute('style', `background: ${normalizedValue}`);
            this.colorInput.emit(normalizedValue);
        }
    }
    handleInputChange(event) {
        event.stopPropagation();
        const value = this.input.value;
        if (value === this.value) {
            return;
        }
        this.value = this.isValidHexCode(value) ? this.normalizeValue(value) : value;
        this.validate();
        if (!this.valueInvalid) {
            this.colorChanged.emit(this.value);
        }
    }
    normalizeValue(value) {
        if (value.length < 3) {
            return value;
        }
        let normalizedValue = value.replace('#', '');
        if (normalizedValue.length === 3) {
            normalizedValue = Array.from(normalizedValue)
                .map((char) => char + char)
                .join('');
        }
        return `#${normalizedValue.toLowerCase()}`;
    }
    isValidHexCode(value) {
        return this.HEX_COLOR_REGEX.test(value);
    }
    componentWillLoad() {
        this.handleValueChange(this.value);
    }
    componentDidLoad() {
        /**
         * This is a temp fix for Last Pass issue of truthy attributes in input fields
         * for example: readonly="false" resolves to readonly
         * TODO: Remove this when Last Pass issue is fixed: https://github.com/redbullmediahouse/rbds-cosmos/issues/2951
         */
        attachObserverToInput(this.input, this.inputObserver);
    }
    render() {
        return (h(Host, { key: 'e799e1e633a377a74c3ad7c3380f213cf38fed5c' }, h("gravity-form-field", { key: '1c46d22788ba27a5357fc928cd39da06fc065edb', disabled: this.disabled, highlighted: this.highlighted, infoBottom: this.infoBottom, infoPosition: this.infoPosition, infoText: this.infoText, infoWidth: this.infoWidth, inline: this.inline, inlineLabelWidth: this.inlineLabelWidth, invalid: !!this.validationMessage || this.valueMissing || this.valueInvalid, label: this.label, onClick: (event) => this.handleFormFieldClick(event), required: this.required, size: this.size, validationMessage: this.getValidationMessage() }, h("div", { key: 'fa20e5e37500040585a526b8a77e499e153005e2', class: generateClassNames({
                'clearable': this.clearable,
                'disabled': this.disabled,
                'has-value': !!this.inputValue,
                'highlighted': this.highlighted,
                'inline': this.inline,
                'invalid': this.invalid || !!this.validationMessage || this.valueMissing || this.valueInvalid,
                'required': this.valueMissing,
                'size': this.size,
            }) }, h("div", { key: 'db7f0a2e200fa1e63136addf4252dd10c019ef3f', class: generateClassNames('input-block') }, h("input", { key: '450c86349e68d917207cd36dcef9ea0a1572eb06', class: generateClassNames('native-input'), onChange: () => this.handleColorSwatchChange(), onInput: (event) => this.handleColorSwatchInput(event), ref: (el) => (this.nativeInput = el), type: "color", value: this.value || '' }), h("div", { key: '2dde3261fa0db401229278748278fb9f733bab73', class: generateClassNames('color-trigger', { empty: !this.value || this.valueInvalid }), onClick: () => this.handleColorTriggerClick(), onKeyDown: (event) => this.handleColorTriggerKeyDown(event), ref: (el) => (this.colorTrigger = el), style: !this.valueInvalid ? { background: this.value } : {} }), h("input", { key: '13e7db746bd5c362f19b01adfab7cd39045ad732', class: generateClassNames('input'), disabled: this.disabled, onChange: (event) => this.handleInputChange(event), onInput: (event) => this.handleInputInput(event), onBlur: () => this.validate(), onFocus: () => this.input.select(), placeholder: this.placeholder, ref: (el) => (this.input = el), required: this.required, tabindex: 1, type: "text", value: this.renderDisplayValue(this.value) }), this.renderClearButton())))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["handleValueChange"]
    }; }
};
GravityColorInput.style = GravityColorInputStyle0;

export { GravityColorInput as gravity_color_input };

//# sourceMappingURL=gravity-color-input.entry.js.map